import { FC } from 'react'

import { ReactComponent as Check } from 'assets/check.svg'

import { CountLSD } from 'components/Claim/CountLSD'

import s from './s.module.scss'

type Props = {
  count: string
}

const ClaimedState: FC<Props> = ({ count }) => {
  return (
    <div className={s.wrapper}>
      <div className={s.description}>
        <div className={s.check}>
          <Check />
        </div>
        <span>Congrats! You claimed all allocated amount</span>
      </div>
      <CountLSD count={count} />
    </div>
  )
}

export { ClaimedState }
